import { EpisodeParticipantRole } from '../episodes/Episodes'

export enum DocumentType {
  INTAKE_FORM = 'INTAKE_FORM',
  ASSESSMENT = 'ASSESSMENT',
  ACTIVITY = 'ACTIVITY',
  OTHER = 'OTHER',
}

export enum DocumentUserType {
  PROVIDER = 'PROVIDER',
  PATIENT = 'PATIENT',
}

export enum EnvelopeStatus {
  CREATED = 'CREATED',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  VOIDED = 'VOIDED',
}

export enum RecipientStatus {
  CREATED = 'CREATED',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
}

export interface DocumentEnvelopeRecipient {
  status: RecipientStatus
  routing_order: number
  recipient_type: DocumentUserType
  signed_date?: string | null
}

export interface DocumentEnvelope {
  id: string
  external_envelope_id: string
  status: EnvelopeStatus
  recipients?: DocumentEnvelopeRecipient[]
}

export interface DocumentShare {
  recipient_id: string
  recipient_type: DocumentUserType | null
  recipient_role?: EpisodeParticipantRole | null
  first_viewed_date?: string | null
}

export interface Document {
  document_id: string
  file_name: string
  created_by_id: string
  created_by_type: DocumentUserType
  episode_id: string
  document_type: DocumentType
  create_date: string
  update_date: string
  is_shared_with_patient?: boolean
  patient_first_viewed_date?: string | null
  shares?: DocumentShare[]
  envelope?: DocumentEnvelope
}

// Upload document response
export interface DocumentUploadResponse {
  document_id: string
  sender_view_url?: string
}

// Share document request
export interface DocumentShareRequest {
  recipient_id: string
}

// Share document response
export interface DocumentShareResponse {
  id: string
  document_id: string
  recipient_id: string
  recipient_type: DocumentUserType
  shared_by_id: string
  shared_by_type: DocumentUserType
  first_viewed_date: string | null
  create_date: string
  update_date: string
  signing_url?: string
}
